<template>
  <div class="coupons">
    <div class="coupons-main">
      <!-- <div class="top-Batch">
        <template>
          <div v-if="upCouponLatest">
            <div class="name">{{ upCouponLatest.couponName }}</div>
            <div class="batch-amount">
              ¥ <span class="price">{{ upCouponLatest.totalMoney }}</span>
            </div>
            <div class="batch-time">
              发放时间：{{ upCouponLatest.couponStartTime }} 至
              {{ upCouponLatest.couponEndTime }}
            </div>
          </div>
        </template>
        <template v-if="!upCouponLatest">
          <div class="notStarted">服务券未开始开放</div>
          <div class="wait">请在发放时间再来看看吧！</div>
        </template>
      </div> -->
      <div class="top-title">
        <img src="@/assets/images/丽水市中小微企业服务券@3x.png" alt="" />
      </div>
      <div class="coupons-tance" @click="ruleTap">
        <div class="title">服务券管理办法</div>
        <div class="content">
          一、总则 （一）为贯彻落实《浙江省经济和信息化委员会、浙江省财政厅关于推广实施小微企业服务券的指导意见》(浙经信企规〔2017〕153号)和《浙江省...
          <span class="highlight">>></span>
        </div>
      </div>
      <div class="coupons-progress">
        <div class="progress-title">
          <div class="title">
            企业领券资格认证
          </div>
        </div>
        <template>
          <progressCom :status="status"></progressCom>
          <div class="status">
            <!-- <div class="status-tab">{{ tab }}</div> -->
            <div class="danger" v-if="status == 2">
              <van-icon name="warning" />
              <div class="rejectInfo">
                <div>审核驳回</div>
                <div class="remark">
                  {{ tab }}
                </div>
              </div>
            </div>
            <van-button
              :type="statusArr[status].type"
              @click="linkTap"
              :icon="statusArr[status].icon"
              :plain="statusArr[status].plain"
              >{{ text }}</van-button
            >
          </div>
        </template>
      </div>
      <div class="go-banner">
        <div @click="onGrabTickets">
          <img src="@/assets/images/点击抢券@3x.png" alt="" />
        </div>
        <div @click="onGoMarket">
          <img src="@/assets/images/点击用券@3x.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 服务券政策 -->
    <van-dialog
      v-model="ruleShow"
      title="服务券管理办法"
      confirmButtonText="知道了"
      confirmButtonColor="#0080FF"
    >
      <div class="rule">
        <p>
          第一章 总则 第一条
          为贯彻落实《浙江省经济和信息化委员会、浙江省财政厅关于推广实施小微企业服务券的指导意见》(浙经信企规〔2017〕153号)和《浙江省人民政府办公厅关于大力培育促进“专精特新”中小企业高质量发展的若干意见》(浙政办发〔2022〕19号)等文件精神,深化财政资金使用方式改革,优化中小微企业创新创业环境,规范我市中小微企业服务券(以下简称服务券)的使用和管理,更好地为中小微企业提供精准有效服务,特制定本办法。
        </p>
        <!-- <p>
          按需申领和政府引导相结合。服务券采用公开形式发放，符合条件的小微企业可按照需求自愿申领。<span
            >服务券只能专项用于抵扣签约服务机构的合同款，不得转让、流通和挪作他用。</span
          >
        </p> -->
      </div>
    </van-dialog>
  </div>
</template>
<script>
import progressCom from './components/progress'
import MSG from './components/msg'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import {
  entCouponStatus,
  listEntCoupon,
  couponTypeList,
  insertOrCoupon,
  findCouponInfo,
  getEntWhiteSettingByType,
  findCurrentTime
} from '@api/coupons/index'
import { Toast } from 'vant'
import { getToken, getLocalStorage, setLocalStorage } from '@utils'
export default {
  components: {
    progressCom
  },
  data() {
    return {
      timeMsg: null,
      timeFlag: null,
      ruleShow: false, // 服务券政策显示隐藏
      status: 0, // 状态
      datasource: '',
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      statusArr: [
        {
          text: '填写信息',
          btnText: '填写信息',
          type: 'info',
          plain: false,
          icon: ''
        },
        {
          text: '请等待管理员审核',
          btnText: '修改申领材料',
          type: 'info',
          plain: true,
          icon: 'warning'
        },
        {
          text: '点击修改信息',
          btnText: '重新填写申领材料',
          type: 'info',
          plain: false
        },
        {
          text: '审核通过',
          btnText: '',
          type: 'primary',
          plain: true,
          icon: 'checked'
        }
      ],
      text: '',
      icon: '',
      time: '',
      tab: '',
      btnText: '',
      active: 0, // 标签栏切换
      listShow: true, // 是否无数据显示空状态
      loading: true,
      finished: false,
      lists: [], // 服务券列表
      mylists: [], // 我的服务券
      typeShow: false, // 服务券类型弹窗显示隐藏
      types: [], // 服务券类型
      pageNum: 1,
      pageSize: 10,
      typeSel: '',
      radio: '', // 选择的服务券类型
      flag: 0,
      isReactiveCoupons: false, // 切换服务券
      upCouponLatest: '', // 上架的服务券批次
      entCouponList: [], // 该劵该发放的企业领取列表
      entLatestCoupon: '', // 该企业最新领取的服务劵
      newTime: null,
      time1: null,
      newFlag: 0
    }
  },
  mounted() {
    if (getToken()) {
      this.getEntCouponStatus()
      this.couponBatch()
      const widths = window.screen.width
      if (widths <= 320) {
        this.windSize = 6
      } else {
        this.windSize = 9
      }
    }
  },
  filters: {
    timeFileter(time) {
      return time.split(' ')[0]
    }
  },
  methods: {
    // 抢券
    onGrabTickets() {
      // this.buriedPoint()
      if (this.upCouponLatest.couponStartTime) {
        this.loveTime(this.newTime)
      } else {
        Toast('服务券还未开始发放')
      }
    },
    // 时间倒计时
    loveTime(timeList) {
      findCurrentTime().then(res => {
        if (res.data.code == '0000') {
          this.time1 = res.data.data
          var the = new Date(timeList.replace(/-/g, '/')).getTime()
          var date = this.time1
          var time = (the - date) / 1000
          var d = parseInt(time / (60 * 60 * 24))
          this.newFlag = d
          if (this.newFlag < 1) {
            this.$emit('dateUp', 1)
          } else {
            Toast('未到抢券时间')
          }
        }
      })
    },
    // 判断是否在时间内填写信息
    getEntWhiteSettingByType() {
      getEntWhiteSettingByType().then(res => {
        if (res.data.code == '0000') {
          this.timeFlag = res.data.data
          this.timeMsg = res.data.msg
        } else {
          Toast(res.data.msg)
        }
      })
    },

    // 时间处理
    timeHandle(m) {
      const time = m.split(' ')[0]
      const days = time.split('-')
      return days[0] + '年' + days[1] + '月' + days[2] + '日'
    },
    // 批次
    couponBatch() {
      findCouponInfo().then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          if (data.upCouponLatest) {
            this.upCouponLatest = data.upCouponLatest
            this.newTime = data.upCouponLatest.couponStartTime
            MSG.$emit('val', data.upCouponLatest.couponStartTime)
            setLocalStorage('couponsId', this.upCouponLatest.id)
            this.upCouponLatest.couponStartTime = this.timeHandle(
              this.upCouponLatest.couponStartTime
            )
            this.upCouponLatest.couponEndTime = this.timeHandle(
              this.upCouponLatest.couponEndTime
            )
          } else {
            MSG.$emit('val', false)
          }
          if (data.entCouponList) {
            this.entCouponList = data.entCouponList.map((value, index) => {
              const lent = value.entName.split('').length
              // if (lent > 9) {
              value.entName =
                value.entName.substr(0, 2) +
                '...' +
                value.entName.substr(lent - 4)
              // }
              return value
            })
          }
          if (data.entLatestCoupon) {
            this.entLatestCoupon = data.entLatestCoupon
          }
        }
      })
    },
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    // 服务券政策
    ruleTap() {
      this.buriedPoint()
      this.$router.push({
        path: '/coupons/rule'
      })
      // this.ruleShow = true
    },
    // 填写申领材料
    linkTap() {
      if (this.flag) {
        // if (this.status == 3) {
        //   Toast('审核已通过')
        //   return
        // }
        if (!this.timeFlag) {
          Toast(this.timeMsg)
          return
        }
        this.buriedPoint()
        this.$router.push({
          path: '/coupons/form',
          query: {
            status: this.status
          }
        })
      } else {
        Toast('暂无权限')
      }
    },
    toggleCoupons() {
      this.isReactiveCoupons = !this.isReactiveCoupons
    },
    // 进入码上中介
    onGoMarket() {
      this.buriedPoint()
      this.$router.push({
        path: '/market/index',
        query: { type: '通用' }
      })
    },
    // 获取状态
    getEntCouponStatus() {
      entCouponStatus().then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          this.status = data.examStatus
          // if (data.examStatus === 3) {
          //   this.isReactiveCoupons = true
          // } else {
          //   this.isReactiveCoupons = false
          // }
          this.datasource = data.datasource
          this.icon = this.statusArr[this.status].icon
          this.text = this.statusArr[this.status].text
          this.time = data.createTime
          this.tab = data.remark ? '备注：' + data.remark : ''
          this.btnText = this.statusArr[this.status].btnText
          this.flag = data.flag
          this.getEntWhiteSettingByType()
        } else {
          Toast(msg)
        }
      })
    },
    // 服务类型列表
    getcCuponTypeList(id) {
      couponTypeList({ id: id }).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          this.types = data
        } else {
          Toast(msg)
        }
      })
    },
    // 获取我的服务券
    getMyCoupon(num) {
      if (num) {
        this.pageNum = 1
        this.mylists = []
        this.loading = true
        this.finished = false
        this.listShow = true
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      listEntCoupon(params).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          this.loading = false
          data.results.forEach(item => {
            let useStatusText = ''
            switch (item.useStatus) {
              case 0:
                useStatusText = '未开始'
                break
              case 2:
                useStatusText = '已过期'
                break
            }
            let arr = {
              ...item,
              useStatusText: useStatusText,
              time:
                '有效期：' +
                item.couponStartTime.split(' ')[0] +
                '至' +
                item.couponEndTime.split(' ')[0]
            }
            this.mylists.push(arr)
          })
          if (data.results.length < this.pageSize) {
            this.finished = true
          } else {
            this.finished = false
          }
          if (this.mylists.length == 0) {
            this.listShow = false
          } else {
            this.listShow = true
          }
        } else {
          Toast(msg)
        }
      })
    },
    // 服务券详情
    detailsTap(id, status) {
      if (status === 0) {
        return
      }
      this.$router.push({
        path: '/coupons/details',
        query: {
          id: id
        }
      })
    },
    // 购买详情
    details(id) {
      this.$router.push({
        path: '/market/listDetails',
        query: {
          id: id
        }
      })
    },
    tabChange(e) {
      if (e === 0) {
        this.getlistCoupon(1)
      } else {
        this.getMyCoupon(1)
        this.buriedPoint()
      }
    },
    // 服务券列表加载更多
    onLoad(e) {
      this.pageNum++
      if (e === 1) {
        this.getMyCoupon()
      } else {
        this.getlistCoupon()
      }
    },
    // 领取服务券
    getTap(id) {
      this.buriedPoint()
      if (this.status != 3) {
        Toast('请先提交服务券申领材料，并审核通过后领取')
      } else {
        this.typeSel = id
        this.getcCuponTypeList(id)
        this.typeShow = true
        this.radio = ''
      }
    },
    getCoupons() {
      const params = {
        couponId: this.typeSel,
        couponTypeName: this.radio
      }
      insertOrCoupon(params).then(res => {
        const { code, data, msg } = res.data
        if (code === '0000') {
          for (let i in this.lists) {
            if (this.lists[i].id == this.typeSel) {
              this.typeShow = false
              this.lists[i].entStatus = 1
              Toast('领取成功')
            }
          }
        } else {
          Toast(msg)
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.coupons {
  width: 100%;
  min-height: 100vh;
  background: url('../../../assets/enterprise/coupons/background@4x.png')
    no-repeat;
  background-size: cover;
  .title {
    position: relative;
    font-weight: 550;
    padding-left: 16px;
    font-size: 18px;
    margin-bottom: 12px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      width: 4px;
      height: 16px;
      border-radius: 4px;
      background-color: rgba(0, 112, 255, 1);
    }
  }
}
.coupons-back {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
}
.coupons-main {
  padding: 15px 15px 80px;
  position: relative;
  z-index: 1;
  /deep/.van-notice-bar {
    height: 32px;
    line-height: 32px;
    border-radius: 15px;
    margin-bottom: 16px;
  }
  /deep/.van-notice-bar__left-icon {
    color: #0080ff;
  }
  .notice-swipe {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
  }
  .top-Batch {
    padding: 0 0 15px;
    color: rgba(255, 255, 255, 100);
    .name {
      font-size: 18px;
    }
    .batch-amount {
      padding: 8px 0 10px;
      .price {
        font-size: 34px;
      }
    }
    .batch-time {
      font-size: 14px;
    }
    .notStarted {
      font-size: 28px;
    }
    .wait {
      font-size: 16px;
      margin: 5px 0 10px;
    }
  }
  .coupons-tance {
    padding: 6px 15px 16px;
    font-size: 16px;
    color: #000;
    background: #ffffff;
    margin-bottom: 12px;
    border-radius: 6px;
    /deep/.van-icon {
      margin-top: -4px;
      vertical-align: middle;
    }
    .content {
      color: rgba(102, 102, 102, 100);
    }
    .highlight {
      color: rgba(0, 112, 255, 100);
    }
  }
  .top-title {
    text-align: center;
    margin: 10px 0 30px;
    font-size: 28px;
    color: rgba(255, 255, 255, 100);
    img {
      width: 100%;
    }
  }
  .coupons-progress {
    background: #fff;
    border-radius: 6px;
    overflow: hidden;
    padding: 6px 15px 16px;
    .progress {
      padding: 0px 0px 10px;
    }
    .progress-title {
      display: flex;
      justify-content: space-between;
      .toggle-coupons {
        box-sizing: border-box;
        text-align: center;
        width: 91px;
        height: 28px;
        line-height: 26px;
        color: rgba(0, 112, 255, 100);
        font-size: 14px;
        border-radius: 14px;
        background-color: rgba(0, 112, 255, 0.1);
        border: 1px solid rgba(0, 112, 255, 0.3);
        cursor: pointer;
      }
    }
    .isHasCouponsBox {
      background: url('../../../assets/enterprise/coupons/couponsBg.png');
      background-size: cover;
      color: #fff;
      padding: 12px;
      box-shadow: 0px 4px 16px 0px rgba(0, 54, 117, 0.25);
      border-radius: 5px;
      .couponsTypeAndTime {
        margin-bottom: 18px;
        .time {
          font-size: 12px;
          margin-bottom: 4px;
          color: rgba(255, 255, 255, 0.75);
        }
        .type {
          font-size: 17px;
        }
      }
      .couponsReceiveInfo {
        display: flex;
        justify-content: space-between;
        > div {
          font-size: 13px;
        }
        .amount {
          font-size: 20px;
          margin-left: 3px;
        }
        .name {
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }
    .status {
      padding: 20px 0 6px;
      border-radius: 10px;
      /deep/.el-button {
        border-radius: 6px;
      }
      .status-icon {
        width: 44px;
        height: 44px;
      }
      &-title {
        font-size: 16px;
        vertical-align: middle;
        margin-top: 12px;
      }
      &-time {
        font-size: 14px;
        color: #999;
        padding: 16px 0 0;
      }
      &-tab {
        font-size: 14px;
        color: #999;
      }
      /deep/.van-button {
        width: 100%;
        letter-spacing: 1px;
      }
      .danger {
        border-radius: 3px;
        background-color: rgba(255, 29, 29, 0.1);
        border: 1px solid rgba(255, 29, 29, 0.3);
        color: rgba(255, 29, 29, 100);
        font-size: 14px;
        padding: 8px 11px;
        display: flex;
        margin-bottom: 12px;
        .rejectInfo {
          margin-left: 4px;
        }
        .van-icon {
          margin-top: 2px;
        }
        .remark {
          color: rgba(51, 51, 51, 100);
          font-size: 12px;
        }
      }
    }
  }
  .go-banner {
    margin-top: 10px;
    background: #ffffff;
    padding: 10px;
    border-radius: 5px;
    img {
      width: 100%;
      border-radius: 5px;
    }
  }
}

.rule {
  padding: 15px;
  p {
    margin: 0;
    line-height: 24px;
    text-indent: 2em;
    font-size: 14px;
    span {
      color: #ff9900;
    }
  }
}

/deep/.van-list__finished-text {
  width: 100%;
}
</style>
